/* eslint-disable no-else-return */
import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect, withRouter } from 'react-router-dom'
import { currentUser } from '../../redux/reducers/user.reducers'
import Loader from '../Loader/Loader'

const PrivateRoute = props => {
  const { authLoading, location, validSession, component, path, name, exact, strict, user } = props

  const routeProps = {
    path,
    component,
    name,
    exact,
    strict,
  }

  if (authLoading) {
    return <Loader noBorder aria-label="Authenticating user" />
  } else if (validSession && user.user_detail.emailVerified && user.user_detail.phoneVerified) {
    return <Route {...routeProps} />
  } else if (
    validSession &&
    (!user.user_detail.emailVerified || !user.user_detail.phoneVerified) &&
    location.pathname === '/activate-account'
  ) {
    return <Route {...routeProps} />
  } else if (validSession && (!user.user_detail.emailVerified || !user.user_detail.phoneVerified)) {
    return <Redirect to="/activate-account" />
  }
  return <Redirect to="/" />
}

const mapStateToProps = state => ({
  validSession: state.userReducers.validSession,
  authLoading: state.userReducers.authLoading,
  user: currentUser(state),
})

export default withRouter(connect(mapStateToProps)(PrivateRoute))
